import React, { Fragment } from 'react'
import { Breadcrumb } from 'antd'
import { InfoCircleOutlined } from '@ant-design/icons';
import { Link, } from 'react-router-dom'
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import Header4 from 'src/components/Header/Header4'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import { MenuCard } from '../component/index'
import { NetIntroduceCardList, NetIntroduceMenuList } from '../component/Datas/normalDatas'
import './style.css'
export default function NetIntroduce(props) {
    const { data } = props;
    return (
        <div className='NetIntroduce' >
            <div className='NetIntroduceMain' id='NetIntroduceMain'>
                <div className='NetIntroduceTitle'>
                    <Header4 />
                </div>
                <div className='NetIntroduceMainScroll' >
                    <div className='NetIntroduceContent'>
                        <div className='NetIntroduceContentMain'>
                            <div className='NetIntroduceContentLeft'>
                                <Breadcrumb>
                                    <Breadcrumb.Item >
                                        <Link to='/Guide'>首页</Link>
                                    </Breadcrumb.Item>
                                    {/*<Breadcrumb.Item >入门知识</Breadcrumb.Item>*/}
                                    <Breadcrumb.Item >平台介绍</Breadcrumb.Item>
                                </Breadcrumb>
                                <div className='NetIntroduceContent_Title'>平台介绍</div>
                                <div className='NetIntroduceContent_Introduce'>作为用户，学习遥感基础知识并且了解如何合理使用本网站资源</div>
                                <div className='NetIntroduceContent_CardList'>
                                    {NetIntroduceCardList.map((card, index) => {
                                        return (
                                            <div className='NetIntroduceContent_Card'>
                                                <MenuCard data={card} key={index} />
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className='NetIntroduceContent_Help'>
                                    <div className='NetIntroduceContent_HelpIcon' />
                                    <InfoCircleOutlined className='NetIntroduceContent_HelpIcon' />
                                    <div className='NetIntroduceContent_HelpText'>需要特定的帮助？</div>
                                </div>

                                <div className='NetIntroduceContent_MenuList'>
                                    {NetIntroduceMenuList.map((menu) => {
                                        return <MenuLocation data={menu} />
                                    })}
                                </div>
                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}

const MenuLocation = (props) => {
    const { data } = props;
    return (
        <div className='NetIntroduceContent_MenuLocation'>
            <Link to={data.location}>
                <div className='NetIntroduceContent_MenuLocationTitle'>{data.title}</div>
            </Link>
            <div className='NetIntroduceContent_MenuLocationIntroduce'>{data.introduce}</div>
            <div className='NetIntroduceContent_MenuLocationBottom' />
        </div>
    )
}